import "rxjs/add/operator/toPromise";

import { Headers, Http } from "@angular/http";

import { AuthService } from "./../auth/auth.service";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { BillingService } from "./billing.service";
import { DownloadPresignedUrls } from "../core/classes/storage";

@Injectable()
export class GetService {
  public apiUrl = environment.apiUrl;
  public showTutorial: boolean = false;
  public showTermsAndCondition: boolean = false;

  constructor(
    public router: Router,
    public http: Http,
    public authService: AuthService,
    public billingService: BillingService
  ) {
    this.showTutorial = localStorage.getItem("showTutorial") === "true";
  }
  public getShowTutorial(): boolean {
    return this.showTutorial;
  }

  public setShowTutorial(showTutorial: boolean): void {
    this.showTutorial = showTutorial;
  }

  public getShowTermsAndCondition(): boolean {
    return this.showTermsAndCondition;
  }

  public setShowTermsAndCondition(showTermsAndCondition: boolean): void {
    this.showTermsAndCondition = showTermsAndCondition;
  }

  public acceptTermsAndConditions(): void {
    this.http
      .post(
        this.apiUrl + "/acceptTermsAndConditions",
        {},
        {
          headers: this.createHeaders(),
        }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  rawRequest(url: string, farm_id?: number) {
    return this.http
      .get(url, {
        headers: this.createHeaders(),
        params: { farm_id: farm_id || 0 },
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  /*request headers*/
  public createHeaders() {
    const headers = new Headers({ Accept: "application/json" });
    if (this.authService.isLoggedIn) {
      headers.append("Authorization", "Bearer " + this.authService.getToken());
    }
    return headers;
  }

  public getBillingStats() {
    return this.http
      .get(this.apiUrl + "/billing/stats", { headers: this.createHeaders() })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getStatic() {
    return this.http
      .get(this.apiUrl + "/static", { headers: this.createHeaders() })
      .toPromise()
      .then((response) => response.json() as any);
  }

  /*auth requests*/
  public logIn(email: string, password: string, language?: string) {
    const body: { email: string; password: string; language?: string } = {
      email: email,
      password: password,
    };

    if (language) {
      body.language = language;
    }
    return this.http
      .post(this.apiUrl + "/oauth/token", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public logOut() {
    return this.http
      .post(this.apiUrl + "/logout", {}, { headers: this.createHeaders() })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public forgotPassword(email: string, language?: string) {
    const body: { email: string; language?: string } = {
      email: email,
    };
    if (language) {
      body.language = language;
    }
    return this.http
      .post(this.apiUrl + "/auth/password/email", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public registerUser(body: any, option?: string, language?: string) {
    if (language) {
      body.language = language;
    }
    return this.http
      .post(this.apiUrl + "/auth/register" + (option ? option : ""), body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getUser() {
    return this.http
      .get(this.apiUrl + "/user/self", { headers: this.createHeaders() })
      .toPromise()
      .then((response) => this.redirectBilling(response))
      .then((response) => response.json() as any);
  }

  public redirectBilling(response) {
    const user = response.json();
    if (user && user.card_required) {
      $("body").addClass("modal-open");
      this.billingService.setShow(true);
    }

    return response;
  }

  public setDefaultUser(body: { language: string }) {
    return this.http
      .post(`${this.apiUrl}/user/set-default-language`, body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getAssistants(status: string) {
    return this.http
      .get(this.apiUrl + "/instructor-assistants", {
        headers: this.createHeaders(),
        params: {
          status: status,
        },
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getVets(status: string) {
    return this.http
      .get(this.apiUrl + "/instructor-vets", {
        headers: this.createHeaders(),
        params: {
          status: status,
        },
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public inviteAssistant(body: any) {
    return this.http
      .post(this.apiUrl + "/invite-assistant", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public requestTrainer(code: string) {
    return this.http
      .post(
        this.apiUrl + "/instructor-request/" + code,
        {},
        { headers: this.createHeaders() }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getInstructorHorses(
    treatment?: boolean,
    q?: string,
    farm_id?: number,
    sort?: any
  ) {
    return this.http
      .get(this.apiUrl + "/instructor-horses", {
        headers: this.createHeaders(),
        params: {
          treatment: true,
          q: q,
          farm_id: farm_id || 0,
          "order[field]": sort.field || "name",
          "order[order]": sort.order || "asc",
        },
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getVetHorses(
    treatment?: boolean,
    q?: string,
    farm_id?: number,
    sort?: any
  ) {
    return this.http
      .get(this.apiUrl + "/vet-horses", {
        headers: this.createHeaders(),
        params: {
          treatment: true,
          q: q,
          farm_id: farm_id || 0,
          "order[field]": sort.field || "name",
          "order[order]": sort.order || "asc",
        },
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getPresignedUrl(assetPaths: Array<DownloadPresignedUrls>) {
    const body: { assetPaths: Array<DownloadPresignedUrls> } = {
      assetPaths: assetPaths,
    };
    return this.http
      .post(this.apiUrl + "/storage/getPresignedUrl", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getHorses(
    treatment?: boolean,
    q?: string,
    farm_id?: number,
    sort?: any
  ) {
    return this.http
      .get(this.apiUrl + "/horse", {
        headers: this.createHeaders(),
        params: {
          treatment: true,
          q: q,
          farm_id: farm_id || 0,
          "order[field]": sort.field || "name",
          "order[order]": sort.order || "asc",
        },
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getWeights(body) {
    return this.http
      .post(this.apiUrl + "/administrative-reports-weight", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getAllHorses() {
    return this.http
      .get(this.apiUrl + "/horses/all", {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getAllInvoices(id?: string) {
    const query = id ? `?after=${id}` : "";
    return this.http
      .get(this.apiUrl + `/billing/invoices${query}`, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getHorse(
    id: number,
    option?: string,
    extra?: string,
    sortTreatmentObj?: any
  ) {
    return this.http
      .get(
        this.apiUrl +
          "/horse/" +
          id +
          (option ? option : "") +
          (extra ? "/" + extra : ""),
        {
          headers: this.createHeaders(),
          params:
            option === "/treatments"
              ? {
                  "order[field]": sortTreatmentObj.field || "treatmentDate",
                  "order[order]": sortTreatmentObj.order || "desc",
                }
              : null,
        }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getHorseA(id: number, option?: string) {
    if (option) {
      return this.http
        .get(this.apiUrl + "/treatment-request/" + id, {
          headers: this.createHeaders(),
        })
        .toPromise()
        .then((response) => response.json() as any);
    }

    return this.http
      .get(this.apiUrl + "/assistant-horse/" + id + (option ? option : ""), {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getHorseV(id: number, option?: string) {
    return this.http
      .get(this.apiUrl + "/vet-horse/" + id + (option ? option : ""), {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateHorse(id: number, body: any, assistant?: boolean) {
    return this.http
      .post(
        this.apiUrl +
          "/" +
          (assistant ? "assistant-" : "") +
          "horse/" +
          id +
          "/update",
        body,
        { headers: this.createHeaders() }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public createHorse(body: any, assistant?: boolean) {
    return this.http
      .post(
        this.apiUrl + "/" + (assistant ? "assistant-" : "") + "horse/",
        body,
        { headers: this.createHeaders() }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public createFarm(body: any) {
    return this.http
      .post(this.apiUrl + "/farm", body, { headers: this.createHeaders() })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateFarm(id: number, body: any) {
    return this.http
      .put(this.apiUrl + "/farm/" + id, body, { headers: this.createHeaders() })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public removeHorse(id: number) {
    return this.http
      .delete(this.apiUrl + "/horse/" + id, { headers: this.createHeaders() })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public removeImages(requestOptions: any) {
    requestOptions.url = this.apiUrl + requestOptions.url;
    requestOptions.headers = this.createHeaders();
    return this.http
      .delete("", requestOptions)
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getTreatments(id: number) {
    return this.http
      .get(this.apiUrl + "/all-treatments/" + id, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getAllFarms() {
    return this.http
      .get(this.apiUrl + "/farms/all", {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getFarms(name?: string) {
    return this.http
      .get(this.apiUrl + "/farm", {
        headers: this.createHeaders(),
        params: {
          name: name,
        },
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getFarm(id?: number) {
    return this.http
      .get(this.apiUrl + "/farm/" + id, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public changeAssistantStatus(id: number, body: any) {
    return this.http
      .post(this.apiUrl + "/change-status/" + id, body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getHorsesTreatments(role?: string) {
    return this.http
      .get(this.apiUrl + role + "/horses-treatments", {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getNotes(
    id: number,
    role: string,
    noteType?: string,
    sortNoteObj?: any
  ) {
    var url = (url =
      this.apiUrl +
      role +
      "/horse/" +
      id +
      "/notes" +
      (noteType ? "/" + noteType : ""));

    if (noteType) {
      url =
        this.apiUrl +
        "/horse/" +
        id +
        "/notes" +
        (noteType ? "/" + noteType : "");
    }

    return this.http
      .get(url, {
        headers: this.createHeaders(),
        params: sortNoteObj
          ? {
              "noteOrder[field]": sortNoteObj.field || "noteDate",
              "noteOrder[order]": sortNoteObj.order || "desc",
            }
          : null,
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public addNote(id: number, role: string, body: any) {
    return this.http
      .post(this.apiUrl + role + "/horse/" + id + "/notes", body, {
        // .post(this.apiUrl + '/horse/' + id + '/notes', body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public addNoteBulk(body: any) {
    return this.http
      .post(this.apiUrl + "/horse/notes-bulk", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateNote(id: number, role: string, body: any) {
    const note_id = body.id;
    return this.http
      .put(this.apiUrl + role + "/horse/" + id + "/notes/" + note_id, body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateNoteById(id: number, role: string, body: any, note_id) {
    return this.http
      .post(this.apiUrl + role + "/horse/" + id + "/notes/" + note_id, body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getLastTreatment(id: number) {
    return this.http
      .get(this.apiUrl + "/horse/" + id + "/last-treatment", {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public createQuickTreatment(role: string, body: any) {
    return this.http
      .post(this.apiUrl + "/treatment/quick-store", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public createTreatment(role: string, body: any) {
    return this.http
      .post(this.apiUrl + role + "/treatment", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public createTreatmentA(role: string, body: any, id: any) {
    return this.http
      .post(this.apiUrl + "/treatment-request/" + id, body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public createTreatmentMA(role: string, body: any) {
    return this.http
      .post(this.apiUrl + "/treatment-request-assistant-bulk", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public createTreatmentV(role: string, body: any, id: any, idI: number) {
    return this.http
      .post(
        this.apiUrl + "/treatment-request/" + id + "/instructor/" + idI,
        body,
        { headers: this.createHeaders() }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public createTreatmentMV(role: string, body: any) {
    return this.http
      .post(this.apiUrl + "/treatment-request-bulk", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateTreatment(role: string, body: any, id: number) {
    return this.http
      .post(this.apiUrl + role + "/treatment/" + id, body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateTreatmentA(role: string, body: any, id: number) {
    return this.http
      .post(this.apiUrl + "/treatment-request/" + id + "/edit", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateTreatmentV(role: string, body: any, id: number) {
    return this.http
      .post(this.apiUrl + "/treatment-request-vet/" + id + "/edit", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public changeTreatmentStatus(id: number, body: any) {
    return this.http
      .post(
        this.apiUrl + "/instructor/treatment/" + id + "/update-status",
        body,
        { headers: this.createHeaders() }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public proceessTreatment(id: number, body: any) {
    return this.http
      .post(this.apiUrl + "/process-treatment-request/" + id, body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public sendFeedback(body: any) {
    return this.http
      .post(this.apiUrl + "/contact-us", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public removeMicrochip(id: number, assistant?: boolean) {
    return this.http
      .delete(
        this.apiUrl +
          "/" +
          (assistant ? "assistant-" : "") +
          "horse/" +
          id +
          "/delete-microchip",
        { headers: this.createHeaders() }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public sendReport(body: any) {
    return this.http
      .post(this.apiUrl + "/treatment-pdf", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public changeName(body: any) {
    return this.http
      .post(this.apiUrl + "/user/self", body, { headers: this.createHeaders() })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public changeInfo(body: any) {
    return this.http
      .post(this.apiUrl + "/user/self/info", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getVaccinations(id: number | string) {
    return this.http
      .get(this.apiUrl + "/horse/" + id + "/vaccinations", {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public addVaccination(id: number | string, body: any) {
    return this.http
      .post(this.apiUrl + "/horse/" + id + "/vaccinations", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public addVaccinationBulk(body: any) {
    return this.http
      .post(this.apiUrl + "/horse/vaccinations-bulk", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public removeVaccination(
    id: number | string,
    vaccinationId: number | string
  ) {
    return this.http
      .delete(this.apiUrl + "/horse/" + id + "/vaccinations/" + vaccinationId, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public archiveHorse(id: number) {
    return this.http
      .post(
        this.apiUrl + "/horse/" + id + "/archive",
        {},
        {
          headers: this.createHeaders(),
        }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public deleteTreatment(id: number, role?: any) {
    return this.http
      .delete(this.apiUrl + role + "/treatment-delete/" + id, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getUnvaccinatedHorses(role?: string, farm_id?: number) {
    return this.http
      .get(this.apiUrl + role + "/in-vaccination", {
        headers: this.createHeaders(),
        params: { farm_id: farm_id || 0 },
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateNotify(notify) {
    return this.http
      .post(this.apiUrl + "/user/notifySettings", notify, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateNotifyFrequencyByType(notify) {
    return this.http
      .post(this.apiUrl + "/user/notifyFrequency", notify, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public deleteNote(horseId: number, noteId: number, role?: any) {
    return this.http
      .delete(this.apiUrl + role + "/horse/" + horseId + "/notes/" + noteId, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public disableOverageNotification() {
    return this.http
      .post(
        this.apiUrl + "/user/disable-overage-notification",
        {},
        {
          headers: this.createHeaders(),
        }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public disableUserNotification(body = {}) {
    return this.http
      .post(this.apiUrl + "/user/confirm-notification", body, {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then((response) => response.json() as any);
  }

  public getHorsesAdministers(body = []) {
    return this.http
      .post(
        this.apiUrl + "/horse/horses_administers",
        { horse_ids: body },
        {
          headers: this.createHeaders(),
        }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public updateHisaId(hisa_id: string) {
    return this.http
      .post(
        this.apiUrl + "/vet/update-hisa-id",
        { hisa_id },
        {
          headers: this.createHeaders(),
        }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }

  public requestNewMedication(medicationName: string) {
    return this.http
      .post(
        this.apiUrl + "/send-medication-request",
        {
          medication: medicationName,
        },
        {
          headers: this.createHeaders(),
        }
      )
      .toPromise()
      .then((response) => response.json() as any);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/get.service.ts